"use client";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Icon from "../icons/Icons";

type FaqItem = {
  question: string;
  answer: string;
};

type FaqProps = {
  items: FaqItem[];
  headingClassName?: string;
};

// Use \n for the next line in FAQ

export default function FAQs({
  items,
  headingClassName = "text-xl xs:text-1.5xl md:text-2xl",
}: FaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-5xl mx-auto sm:p-4">
      <h2
        className={`${headingClassName} font-bold text-center text-primaryBlack`}
      >
        Frequently Asked Questions
      </h2>
      <p className="text-2xs sm:text-base text-center text-[#404040] mb-6">
        Everything You Need To Know To Get Started With Confidence
      </p>

      <div className="space-y-3.5 sm:space-y-5">
        {items.map(({ question, answer }, index) => {
          const isActive = openIndex === index;

          return (
            <div
              key={index}
              className={`border-2 rounded-xl px-4 sm:px-7 overflow-hidden transition ${isActive ? "bg-linear-to-b/srgb from-white to-[#D8E9FF] border-[#1A51AA3D]" : "bg-white border-[#1A51AA3D]"}`}
            >
              <div aria-label={question} className="w-full">
                <button
                  onClick={() => handleToggle(index)}
                  className={[
                    "w-full flex justify-between items-center py-2.5 sm:py-5 text-sm xs:text-base md:text-lg font-medium transition text-left",
                    isActive ? "text-primaryBlue" : "text-primaryBlack",
                  ].join(" ")}
                >
                  {question}

                  <Icon.expandableIcon isOpen={isActive} />
                </button>
              </div>

              <AnimatePresence initial={false}>
                {isActive && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <div className="text-primaryBlack text-xs xs:text-sm md:text-base font-normal pb-3 sm:pb-4 pt-0">
                      <div
                        className="prose faq-content text-primaryBlack text-xs xs:text-sm md:text-base font-light pb-3 sm:pb-4 pt-0"
                        dangerouslySetInnerHTML={{ __html: answer }}
                      />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
}
